import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-question-check",
  "use": "icon-question-check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-question-check\"><path d=\"M24,16v8h-8c-2.955,0-5.535-1.615-6.92-4.004,1.751-.013,3.399-.444,4.864-1.184l1.653,1.602c.391,.391,.904,.586,1.417,.586,.51,0,1.019-.193,1.403-.578l3.793-3.707-1.398-1.43-3.812,3.704-1.313-1.273c2.596-1.995,4.284-5.114,4.309-8.636,2.389,1.385,4.004,3.965,4.004,6.92Zm-15,2H0V9C0,4.037,4.038,0,9,0s9,4.037,9,9-4.037,9-9,9Zm1-6h-2v2.077h2v-2.077Zm1.953-5.535c-.213-1.212-1.208-2.206-2.417-2.417-.886-.161-1.783,.081-2.463,.653-.682,.572-1.072,1.41-1.072,2.299h2c0-.297,.13-.576,.358-.767,.23-.193,.526-.271,.832-.216,.391,.068,.725,.401,.793,.793,.093,.531-.212,.907-.502,1.066-.845,.465-1.481,1.595-1.481,2.628v.495h2v-.495c0-.312,.26-.773,.447-.876,1.124-.621,1.729-1.892,1.506-3.164Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/question-check.svg
// module id = c9SP
// module chunks = 63